import { createActionGroup, createReducer, createSelector, on, props } from '@ngrx/store';
import { ZagentMiniConfig } from '@zerops/zerops/core/zerops-services';

// ROOT-registered slice (StoreModule.forFeature in app.config.ts) that carries a
// pending control-plane (zagentConfig) across the unauthed handoff → secret-pause
// redirect. The deep-link reader's own zagentConfigMap lives in the LAZY
// RecipePageModule, so it can't be seeded from the root handoff effect; this slice
// can (it's always loaded). Key format mirrors zagentConfigMap: `${recipeSlug}:${environmentKey}`.
export const PENDING_DEPLOY_CONFIG_FEATURE_NAME = 'pending-deploy-config';

export const pendingDeployConfigActions = createActionGroup({
  source: PENDING_DEPLOY_CONFIG_FEATURE_NAME,
  events: {
    'set': props<{ recipeSlug: string; environmentKey: string; config: ZagentMiniConfig }>(),
    'clear': props<{ recipeSlug: string; environmentKey: string }>()
  }
});

export interface PendingDeployConfigState {
  // Map key format: `${recipeSlug}:${environmentKey}`
  configMap: Record<string, ZagentMiniConfig>;
}

export const pendingDeployConfigInitialState: PendingDeployConfigState = {
  configMap: {}
};

export const pendingDeployConfigReducer = createReducer(
  pendingDeployConfigInitialState,

  on(pendingDeployConfigActions.set, (state, { recipeSlug, environmentKey, config }) => ({
    ...state,
    configMap: {
      ...state.configMap,
      [`${recipeSlug}:${environmentKey}`]: config
    }
  })),

  on(pendingDeployConfigActions.clear, (state, { recipeSlug, environmentKey }) => {
    const newMap = { ...state.configMap };
    delete newMap[`${recipeSlug}:${environmentKey}`];
    return { ...state, configMap: newMap };
  })
);

export const selectPendingDeployConfigState =
  (state: any) => state[PENDING_DEPLOY_CONFIG_FEATURE_NAME] as PendingDeployConfigState;

export const selectPendingDeployConfigMap = createSelector(
  selectPendingDeployConfigState,
  (state) => state?.configMap ?? {}
);
